import React, { useState,useEffect } from "react";
import { toast } from 'react-toastify';
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const StyleTab = ({updateClickToCallTabData,clickToCallTabData}) => {
    const [activeStyleElementsTab, setActiveStyleElementsTab] = useState("main");
    const [buttonBackgroundColor, setButtonBackgroundColor] = useState(clickToCallTabData.style_button_color);
    const [buttonIconTextColor, setButtonIconTextColor] = useState(clickToCallTabData.style_button_icon_text_color);
    const [windowBackgroundColor, setWindowBackgroundColorColor] = useState(clickToCallTabData.style_window_background_color);
    const [windowMessageColor, setWindowMessageColor] = useState(clickToCallTabData.style_window_message_color);
    const [windowMessagePhoneNumber, setWindowMessagePhoneNumberColor] = useState(clickToCallTabData.style_window_phone_number_color);
    const [buttonSize, setButtonSize] = useState(clickToCallTabData.style_button_size);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(clickToCallTabData.style_custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(clickToCallTabData.style_custom_js);
    
    // Handlers Button Size Change
    const handleButtonSizeChange = (e) => {
        const value = e.target.value;
        setButtonSize(value);
        updateClickToCallTabData("style_button_size", value);
    };

    //Name Font Size
    const [selectedNameFontSize, setSelectedNameFontSize] = useState(clickToCallTabData.style_name_font_size);
    const [showNameFontSizeDropdown, setShowNameFontSizeDropdown] = useState(false);
    const layoutNameFontSizeValues = ["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px", "18px", "19px", "20px", "30px", "40px", "50px"];
    const toggleNameFontSizeDropdown = () => {
        setShowNameFontSizeDropdown(!showNameFontSizeDropdown);
    };
    const handleNameFontSizeSelect = (spacing) => {
        setSelectedNameFontSize(spacing);
        setShowNameFontSizeDropdown(false);
        updateClickToCallTabData("style_name_font_size", spacing);
    };

    //Caption Font Size
    const [selectedCaptionFontSize, setSelectedCaptionFontSize] = useState(clickToCallTabData.style_caption_font_size);
    const [showCaptionFontSizeDropdown, setShowCaptionFontSizeDropdown] = useState(false);
    const layoutCaptionFontSizeValues = ["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px", "18px", "19px", "20px", "30px", "40px", "50px"];
    const toggleCaptionFontSizeDropdown = () => {
        setShowCaptionFontSizeDropdown(!showCaptionFontSizeDropdown);
    };
    const handleCaptionFontSizeSelect = (spacing) => {
        setSelectedCaptionFontSize(spacing);
        setShowCaptionFontSizeDropdown(false);
        updateClickToCallTabData("style_caption_font_size", spacing);
    };

    //Message Font Size
    const [selectedMessageFontSize, setSelectedMessageFontSize] = useState(clickToCallTabData.style_message_font_size);
    const [showMessageFontSizeDropdown, setShowMessageFontSizeDropdown] = useState(false);
    const layoutMessageFontSizeValues = ["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px", "18px", "19px", "20px", "30px", "40px", "50px"];
    const toggleMessageFontSizeDropdown = () => {
        setShowMessageFontSizeDropdown(!showMessageFontSizeDropdown);
    };
    const handleMessageFontSizeSelect = (spacing) => {
        setSelectedMessageFontSize(spacing);
        setShowMessageFontSizeDropdown(false);
        updateClickToCallTabData("style_message_font_size", spacing);
    };

    //Phone Number Font Size
    const [selectedPhoneNumberFontSize, setSelectedPhoneNumberFontSize] = useState(clickToCallTabData.style_phone_number_font_size);
    const [showPhoneNumberFontSizeDropdown, setShowPhoneNumberFontSizeDropdown] = useState(false);
    const layoutPhoneNumberFontSizeValues = ["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px", "18px", "19px", "20px", "30px", "40px", "50px"];
    const togglePhoneNumberFontSizeDropdown = () => {
        setShowPhoneNumberFontSizeDropdown(!showMessageFontSizeDropdown);
    };
    const handlePhoneNumberFontSizeSelect = (spacing) => {
        setSelectedPhoneNumberFontSize(spacing);
        setShowPhoneNumberFontSizeDropdown(false);
        updateClickToCallTabData("style_phone_number_font_size", spacing);
    };

    //Button Animation
    /*const [isButtonAnimationToggleEnabled, setIsEnableButtonAnimationEnabled] = useState(false);
    const setingEnableAnimationIntervalRef = useRef(null);
    useEffect(() => {
        const checkbox = setingEnableAnimationIntervalRef.current;
        if (checkbox) {
            setIsEnableButtonAnimationEnabled(checkbox.checked);
        }
    }, []);
    const handleEnableButtonAnimationToggle = () => {
        setIsEnableButtonAnimationEnabled(setingEnableAnimationIntervalRef.current.checked);
    };

    //Animation interval Sec
    const [selectedAnimationintervalSec, setSelectedAnimationintervalSec] = useState(20);
    const [showAnimationintervalSecDropdown, setShowAnimationintervalSecDropdown] = useState(false);
    const layoutAnimationintervalSecValues = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 30, 40, 50];
    const toggleAnimationintervalSecDropdown = () => {
        setShowAnimationintervalSecDropdown(!showAnimationintervalSecDropdown);
    };
    const handleAnimationintervalSecSelect = (spacing) => {
        setSelectedAnimationintervalSec(spacing);
        setShowAnimationintervalSecDropdown(false);
    };*/

    // Handlers  button Background Color Change
    const handleButtonBackgroundColorChange = (color) => {
        setButtonBackgroundColor(color.hex);
        updateClickToCallTabData("style_button_color", color.hex);
    };

    // Handlers Button Icon & Text Color Change
    const handleButtonIconTextColorChange = (color) => {
        setButtonIconTextColor(color.hex);
        updateClickToCallTabData("style_button_icon_text_color", color.hex);
    };

    // Handlers Window Background Color Change
    const handleWindowBackgroundColorChange = (color) => {
        setWindowBackgroundColorColor(color.hex);
        updateClickToCallTabData("style_window_background_color", color.hex);
    };

    // Handlers Window Message Color Change
    const handleWindowMessageColorChange = (color) => {
        setWindowMessageColor(color.hex);
        updateClickToCallTabData("style_window_message_color", color.hex);
    };

    // Handlers Window Message Phone Number Color Change
    const handleWindowMessagePhoneNumberColorChange = (color) => {
        setWindowMessagePhoneNumberColor(color.hex);
        updateClickToCallTabData("style_window_phone_number_color", color.hex);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateClickToCallTabData("style_custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateClickToCallTabData("style_custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="click-to-call-side-baar-style-tab">
            {activeStyleElementsTab === "main" && (
            <>
                <span>Style</span>
                <div className="side-baar-box-header">
                    <div className="box-header-row">
                        <span>Button Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={buttonBackgroundColor} setColor={setButtonBackgroundColor}  onChangeComplete={handleButtonBackgroundColorChange}/>
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Button Icon & Text Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={buttonIconTextColor} setColor={setButtonIconTextColor}  onChangeComplete={handleButtonIconTextColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Window Background Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={windowBackgroundColor} setColor={setWindowBackgroundColorColor}  onChangeComplete={handleWindowBackgroundColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Window Message Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={windowMessageColor} setColor={setWindowMessageColor}  onChangeComplete={handleWindowMessageColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Window Phone Number Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={windowMessagePhoneNumber} setColor={setWindowMessagePhoneNumberColor} onChangeComplete={handleWindowMessagePhoneNumberColorChange} />
                        </div>
                    </div>
                </div>

                <div className="side-baar-box-header">
                    <div className="box-header-row">
                        <span>Font</span>
                        <em>Default</em>
                    </div>
                    <div className="box-header-row">
                        <span>Button Size</span>
                        <em>{buttonSize}px</em>
                        <div className="slider-container">
                            <input type="range" min="40" max="100" value={buttonSize} onChange={handleButtonSizeChange}/>
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Name Font Size</span>
                        <em onClick={toggleNameFontSizeDropdown}>{selectedNameFontSize}</em>
                        {showNameFontSizeDropdown && (
                            <ul className="dropdown-list">
                                {layoutNameFontSizeValues.map((spacing) => (
                                    <li key={spacing} onClick={() => handleNameFontSizeSelect(spacing)}>
                                        {spacing}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="box-header-row">
                        <span>Caption Font Size</span>
                        <em onClick={toggleCaptionFontSizeDropdown}>{selectedCaptionFontSize}</em>
                        {showCaptionFontSizeDropdown && (
                            <ul className="dropdown-list">
                                {layoutCaptionFontSizeValues.map((spacing) => (
                                    <li key={spacing} onClick={() => handleCaptionFontSizeSelect(spacing)}>
                                        {spacing}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="box-header-row">
                        <span>Message Font Size</span>
                        <em onClick={toggleMessageFontSizeDropdown}>{selectedMessageFontSize}</em>
                        {showMessageFontSizeDropdown && (
                            <ul className="dropdown-list">
                                {layoutMessageFontSizeValues.map((spacing) => (
                                    <li key={spacing} onClick={() => handleMessageFontSizeSelect(spacing)}>
                                        {spacing}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="box-header-row">
                        <span>Phone Number Font Size</span>
                        <em onClick={togglePhoneNumberFontSizeDropdown}>{selectedPhoneNumberFontSize}</em>
                        {showPhoneNumberFontSizeDropdown && (
                            <ul className="dropdown-list">
                                {layoutPhoneNumberFontSizeValues.map((spacing) => (
                                    <li key={spacing} onClick={() => handlePhoneNumberFontSizeSelect(spacing)}>
                                        {spacing}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {/*<div className="side-baar-box-header">
                    <div className="box-header-row">
                        <span>Button Animation</span>
                        <div className="form-group">
                            <input id="button_animation_toggle" className="chkbx-toggle" type="checkbox" value="1" ref={setingEnableAnimationIntervalRef} onChange={handleEnableButtonAnimationToggle} defaultChecked={true}/>
                            <label for="button_animation_toggle"></label>
                        </div>
                    </div>
                    {isButtonAnimationToggleEnabled && (
                        <div className="box-header-row">
                            <span>Animation interval</span>
                            <em onClick={toggleAnimationintervalSecDropdown}>{selectedAnimationintervalSec}sec</em>
                            {showAnimationintervalSecDropdown && (
                                <ul className="dropdown-list">
                                    {layoutAnimationintervalSecValues.map((spacing) => (
                                        <li key={spacing} onClick={() => handleAnimationintervalSecSelect(spacing)}>
                                            {spacing}sec
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )}
                </div>*/}

                <div className="customize-elements-list">
                    <ul>
                        <li>
                            <button onClick={() => setActiveStyleElementsTab("custom_css")}>Custom CSS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                        </li>
                        <li>
                            <button onClick={() => setActiveStyleElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                        </li>
                    </ul>
                </div>
            </>
            )}

            {activeStyleElementsTab === "custom_css" && (
            <>
                <div className="inner-box-layout">
                    <span><button onClick={() => setActiveStyleElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                    <div className="css-text height-text">
                        <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                    </div>
                </div>
            </>
        )}

        {activeStyleElementsTab === "custom_js" && (
            <>
                <div className="inner-box-layout">
                    <span><button onClick={() => setActiveStyleElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                    <div className="css-text height-text">
                        <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                        <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                    </div>
                </div>
            </>
        )}
        </div>
    );
};

export default StyleTab;